import styled, { css } from 'styled-components';

export const cssNudgeDialog = css`
  width: 226px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  z-index: 1;
`;

export const VideoWrapper = styled.video`
  width: 360px;

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;
